<script setup lang="ts">
import Tag from "./detail/tag.vue";
import Region from "./detail/region.vue";
import Language from "./detail/language.vue";
import Manufacturer from "./detail/manufacturer.vue";
import Media from "./detail/media.vue";
import Release from "./detail/release.vue";
import Franchise from "./detail/franchise.vue";
import Gender from "./detail/gender.vue";

defineProps<{
  accessoryId: string;
}>();
</script>

<template>
  <section class="tab-accessory">
    <div class="content">
      <!-- Tags -->
      <Tag :accessory-id="accessoryId" />

      <!-- Regions -->
      <Region :accessory-id="accessoryId" />

      <!-- Languages -->
      <!-- <Language :accessory-id="accessoryId" /> -->

      <!-- Manufacturers -->
      <!-- <Manufacturer :accessory-id="accessoryId" /> -->

      <!-- medias -->
      <!-- <Media :accessory-id="accessoryId" /> -->

      <!-- Releases -->
      <!-- <Release :accessory-id="accessoryId" /> -->

      <!-- Franchises -->
      <!-- <Franchise :accessory-id="accessoryId" /> -->

      <!-- Genders -->
      <!-- <Gender :accessory-id="accessoryId" /> -->
    </div>
  </section>
</template>

<style lang="scss" scoped>
.tab-accessory {
  display: flex;
  flex-direction: column;
  padding-block: 1rem;
  gap: 1rem;

  .content {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
}

@media screen and (max-width: 1024px) {
  .tab-game {
    .content {
      padding-inline: 0;
    }
  }
}
</style>
